import {setStyles} from '../../utils/iterators/setStyles';

const isImgLoad = ( img ) => {
	return img && img.complete && img.naturalWidth > 0 && img.naturalHeight > 0;
};

export default class NewSlideshow {
	constructor ( {
		element,
		loop = false,
		autoWidth = false,
		bookmarks,
		switchCallback = () => {},
	} )
	{
		this._element = element;
		this._loop = loop;
		this._autoWidth = autoWidth;
		
		this._switchCallback = switchCallback;

		this._slidesContainer = this._element.querySelector( '[data-slider-role="slides"]' );
		this._slides = Array.from( this._slidesContainer.children );
		this._slidesCount = this._slides.length;
		this._buttons = this._element.querySelector( '[data-slider-role="buttons"]' );
		this._bookmarksContainer = this._element.querySelector( '[data-slider-role="bookmarks"]' ) || bookmarks;
		this._bookmarks = this._counter = this._direction = this._href = this._slidesLength = this._step = this._timeStamp = this._touch = null;
		
		this._currentIndex = 0;
		this._currentPosition = 0;

		this._initValues = this._initValues.bind( this );
		this._handleBookmarksClick = this._handleBookmarksClick.bind( this );
		this._handleButtonsClick = this._handleButtonsClick.bind( this );
		this._handleDragEnd = this._handleDragEnd.bind( this );
		this._handleDragMove = this._handleDragMove.bind( this );
		this._handleDragStart = this._handleDragStart.bind( this );
		this._handleLinkClick = this._handleLinkClick.bind( this );
		
		this.updateSizes = this.updateSizes.bind( this );
	}

	init()
	{
		if ( this._slidesCount < 2 )
		{
			return;
		}
		
		this._loadImages();
		this._initValues();
		this._initTouch();
		this._initBookmarks();
		
		window.addEventListener( 'resize', this.updateSizes );
	}
	
	updateSizes()
	{
		const direction = this._currentPosition > 0 ? 1 : -1;
		const prevStep = this._step;
		
		if ( this._autoWidth )
		{
			this._calculateAutoWidthStep();
			this._calculateAutoWidthPosition();
			this._adjustSlides();
		}
		else
		{
			this._step = this._calculateStep( this._slides[0] );
			this._currentPosition = this._currentIndex * this._step * direction;
		}
		
		setStyles( this._slidesContainer, {
			transform: `matrix( 1, 0, 0, 1, ${this._currentPosition}, 0 )`,
			transition: 'none'
		} );
		
		const offsetSlides = Array.from( this._slidesContainer.children )
			.filter( ( slide ) => {
				return slide.classList.contains( `clone` )
					&& slide.style.position === `absolute`
					&& slide.style.left
			} )
			
		offsetSlides.forEach( ( slide, index ) => {
				setStyles( slide, {
					position: `absolute`,
					left: `${this._step * (offsetSlides.length - index) * direction}px`
				} );
			} );
		
		this._initBookmarks();
		this._disableButtons();
		this._switchCallback();
	}

	_adjustSlides ()
	{
		if ( this._loop )
		{
			return;
		}
		
		this._updateSlidesLength();

		if ( this._currentPosition < this._slidesContainer.offsetWidth - this._slidesLength )
		{
			this._currentPosition = this._slidesContainer.offsetWidth - this._slidesLength;
			
			if ( this._currentIndex >= this._slidesCount - 1 )
			{
				this._currentIndex = this._slidesCount - 1;
			}
			
			if ( this._currentPosition > 0 )
			{
				this._currentPosition = 0;
				this._currentIndex = 0;
			}
			
			/* Если в ленте последние 2 слайда не занимают ширину контейнера,
				переключение на предудыщий слайд не происходит */
			// this._currentIndex = this._slides.length - 1;
		}
		else if ( this._currentPosition > 0 )
		{
			this._currentPosition = 0;
			this._currentIndex = 0;
		}
	}

	_calculateStep ( element )
	{
		const elementStyle = element.currentStyle || window.getComputedStyle( element );
		const elementWidth = element.offsetWidth;
		const elementMargin = parseFloat( elementStyle.marginRight );

		return elementWidth + elementMargin;
	}

	_createClones ( count )
	{
		for ( let i = 0; i < count; i++ )
		{
			const firstClone = this._slides[i].cloneNode( true );
			const lastClone = this._slides[this._slidesCount - 1 - i].cloneNode( true );

			firstClone.classList.add( 'clone' );
			lastClone.classList.add( 'clone' );

			setStyles( lastClone, {
				position: 'absolute',
				left: this._step * ( i + 1 ) * -1 + 'px'
			} );

			Array.from( firstClone.querySelectorAll( '[id]' ) ).forEach( ( it ) => {
				it.removeAttribute( 'id' );
			} );

			Array.from( lastClone.querySelectorAll( '[id]' ) ).forEach( ( it ) => {
				it.removeAttribute( 'id' );
			} );

			this._slidesContainer.append( firstClone );
			this._slidesContainer.insertBefore( lastClone, this._slidesContainer.children[0] );
		}
	}

	_createLoop ()
	{
		this._currentIndex = this._currentIndex < 0 ? this._slidesCount - 1 : 0;
		this._currentPosition = this._currentIndex * this._step * -1;

		setStyles( this._slidesContainer, {
			transform: `matrix( 1, 0, 0, 1, ${this._currentPosition}, 0 )`,
			transition: 'none',
		} );
	}
	
	_showNecessaryAutoWidthButtons()
	{
		/* Если не все картинки не имеют ширину в момент инициализации, кнопки не отобразаятся */
		if ( this._autoWidth && this._slidesLength > this._slidesContainer.offsetWidth && !this._buttons.classList.contains( 'show' ) )
		{
			this._buttons.classList.add( 'show' );
		}
	}

	_disableButtons ()
	{
		if ( this._loop || !this._buttons )
		{
			return;
		}
		
		this._showNecessaryAutoWidthButtons();
		
		const maxAbsOffset = Math.abs( this._slidesLength - this._slidesContainer.offsetWidth );
		const currentAbsOffset = Math.abs( this._currentPosition );

		this._buttons.querySelector( '.prev' ).classList.remove( 'disabled' );
		this._buttons.querySelector( '.next' ).classList.remove( 'disabled' );

		if ( this._currentPosition >= 0 )
		{
			this._buttons.querySelector( '.prev' ).classList.add( 'disabled' );
		}

		if ( currentAbsOffset >= maxAbsOffset || this._slidesLength < this._slidesContainer.offsetWidth )
		{
			this._buttons.querySelector( '.next' ).classList.add( 'disabled' );
		}
	}

	_getXCoordinate ( evt )
	{
		return typeof evt.pageX === 'number' ? evt.pageX : evt.touches[0].pageX;
	}

	_getYCoordinate ( evt )
	{
		return typeof evt.pageY === 'number' ? evt.pageY : evt.touches[0].pageY;
	}
	
	_calculateAutoWidthStep ()
	{
		if ( this._autoWidth )
		{
			const slideIndex = this._currentIndex === ( this._slidesCount - 1 )
				? this._currentIndex - 1
				: this._currentIndex;
			
			this._step = this._calculateStep( this._slides[slideIndex] );
		}
		
		return this._step;
		// step = this._calculateStep( this._slides[this._currentIndex] );
	}
	
	_calculateAutoWidthPosition()
	{
		let position = 0;
		
		for ( let i = 0; i < this._currentIndex && i < this._slidesCount; i++ )
		{
			position -= this._calculateStep( this._slides[i] );
		}
		
		this._currentPosition = position;
		
		return this._currentPosition;
		// this._currentPosition = this._currentIndex * this._step * -1;
	}

	_handleBookmarksClick ( evt )
	{
		if ( evt.target.classList.contains( 'current' ) || this._slidesContainer.classList.contains( 'sliding' ) )
		{
			return;
		}
		
		const requestedIndex = this._bookmarks.indexOf( evt.target );
		
		if ( requestedIndex < 0 )
		{
			return;
		}
		
		const diff = Math.abs( this._currentIndex - requestedIndex );
		
		this._calculateAutoWidthStep();

		this._currentIndex = requestedIndex;
		this._calculateAutoWidthPosition();
		this._adjustSlides();

		setStyles( this._slidesContainer, {
			transform: `matrix( 1, 0, 0, 1, ${this._currentPosition}, 0 )`,
			transition: `transform ${0.4 * diff}s ease-in-out`,
		} );

		this._handleTransition();
	}

	_handleButtonsClick ( evt )
	{
		if ( this._slidesContainer.classList.contains( 'sliding' ) )
		{
			return;
		}
		
		this._updateSlidesLength();

		let step = this._step;

		if ( this._autoWidth )
		{
			step = this._calculateAutoWidthStep();
		}
		else if ( Math.abs( this._step ) !== 0 )
		{
			while ( step < this._slidesContainer.offsetWidth )
			{
				step += this._step;
			}
		}

		this._slidesContainer.style.transition = '';
		this._direction = evt.target.classList.contains( 'prev' ) ? 1 : -1;
		this._currentIndex -= this._direction;
		
		if ( this._autoWidth )
		{
			/* Код ниже решает проблему необходимости множественного клика 
			при пролистывании слайдов назад, когда несколько последних слайдов 
			целиком помещаются в контейнер */
			if ( this._direction === 1 )
			{
				let finalIndex = 0;
				let slidesLength = 0;
			
				for ( let i = 0; i < this._slidesCount; i++ )
				{
					const nextCalculateLength = slidesLength + ( -1 * this._calculateStep( this._slides[i] ) );
					
					if ( this._currentPosition < slidesLength && this._currentPosition >= nextCalculateLength )
					{
						if ( finalIndex >= this._slidesCount - 1 )
						{
							finalIndex = this._slidesCount - 1;
						}
						else if ( finalIndex < 0 )
						{
							finalIndex = 0;
						}
						
						break;
					}
					
					finalIndex++;
					slidesLength = nextCalculateLength;
				}
				
				this._currentIndex = finalIndex;
			}
			
			this._calculateAutoWidthPosition();
		}
		else
		{
			this._currentPosition += step * this._direction;
		}
		
		this._adjustSlides();
		this._slidesContainer.style.transform = `matrix( 1, 0, 0, 1, ${this._currentPosition}, 0 )`;
		this._handleTransition();
	}

	_handleDragEnd ( evt )
	{
		if ( this._touch.started )
		{
			this._slidesContainer.classList.remove( 'sliding', 'grabbing' );

			if ( this._href )
			{
				location.href = this._href;
			}
		}
		else
		{
			let finalIndex = 0;
			
			if ( this._autoWidth )
			{
				this._calculateAutoWidthStep();
				
				if ( this._touch.position < 0 )
				{
					let slidesLength = 0;
				
					for ( let i = 0; i < this._slidesCount; i++ )
					{
						const nextCalculateLength = slidesLength + ( -1 * this._calculateStep( this._slides[i] ) );
						
						if ( this._touch.position <= slidesLength && this._touch.position > nextCalculateLength )
						{
							if ( finalIndex >= this._slidesCount - 1 )
							{
								finalIndex = this._slidesCount - 1;
							}
							else if ( finalIndex < 0 )
							{
								finalIndex = 0;
							}
							// to right (next)
							else if ( this._direction === -1 )
							{
								finalIndex++;
							}
							
							break;
						}
						
						finalIndex++;
						slidesLength = nextCalculateLength;
					}
				}
			}
			else
			{
				finalIndex = Math.round( this._touch.position / this._step * -1 );

				if ( finalIndex === this._currentIndex )
				{
					finalIndex = finalIndex - this._direction;
				}

				if ( !this._loop )
				{
					if ( finalIndex < 0 )
					{
						finalIndex = 0;
					}
					else if ( finalIndex >= this._slidesCount )
					{
						finalIndex = this._slidesCount - 1;
					}
				}
			}

			this._currentIndex = finalIndex;
			this._calculateAutoWidthPosition();
			this._adjustSlides();

			setStyles( this._slidesContainer, {
				transform: `matrix( 1, 0, 0, 1, ${this._currentPosition}, 0 )`,
				transition: '',
			} );

			this._handleTransition();
		}

		this._touch = null;
		document.removeEventListener( 'mousemove', this._handleDragMove );
		document.removeEventListener( 'touchmove', this._handleDragMove );
		document.removeEventListener( 'mouseleave', this._handleDragEnd );
		document.removeEventListener( 'mouseout', this._handleDragEnd );
		document.removeEventListener( 'mouseup', this._handleDragEnd );
		document.removeEventListener( 'touchcancel', this._handleDragEnd );
		document.removeEventListener( 'touchend', this._handleDragEnd );
		document.removeEventListener( 'touchleave', this._handleDragEnd );
	}

	_handleDragMove ( evt )
	{
		if ( !this._touch.started && !this._slidesContainer.classList.contains( 'sliding' ) )
		{
			return;
		}
		
		const xCoordinate = this._getXCoordinate( evt );
		const yCoordinate = this._getYCoordinate( evt );

		if ( this._touch.started )
		{
			this._touch.started = false;
			
			if ( Math.abs( this._touch.xCoordinate - xCoordinate ) >= Math.abs( this._touch.yCoordinate - yCoordinate ) )
			{
				this._slidesContainer.classList.add( 'sliding' );
			}
			else
			{
				return;
			}
		}

		if ( evt.cancelable )
		{
			evt.preventDefault();
		}
		
		const direction = this._touch.xCoordinate < xCoordinate ? 1 : -1;
		const diff = Math.abs( this._touch.xCoordinate - xCoordinate );
		
		this._touch.position = this._currentPosition + diff * direction;

		if (
				!this._loop
			&&	( this._touch.position > 0 || this._touch.position < this._slidesContainer.offsetWidth - this._slidesLength )
		)
		{
			this._touch.position = this._currentPosition + diff / 3 * direction;
		}

		this._slidesContainer.style.transform = `matrix( 1, 0, 0, 1, ${this._touch.position}, 0 )`;
		this._direction = direction;
		this._currentPosition = this._touch.position;
		this._touch.xCoordinate = xCoordinate;
		this._disableButtons();
	}

	_handleDragStart ( evt )
	{
		if (
			( evt.timeStamp === this._timeStamp )
		||	( evt.button && evt.button > 0 )
		||	( evt.touches && evt.touches.length !== 1 )
		||	this._slidesContainer.classList.contains( 'sliding' )
		)
		{
			return;
		}

		if ( evt.type === 'mousedown' )
		{
			evt.preventDefault();
		}

		this._timeStamp = evt.timeStamp;
		this._slidesContainer.classList.add( 'grabbing' );
		this._slidesContainer.style.transition = 'none';

		this._touch = {
			position: this._currentPosition,
			started: true,
			xCoordinate: this._getXCoordinate( evt ),
			yCoordinate: this._getYCoordinate( evt )
		};

		document.addEventListener( 'mousemove', this._handleDragMove );
		document.addEventListener( 'touchmove', this._handleDragMove, {passive: false} );
		document.addEventListener( 'mouseup', this._handleDragEnd );
		document.addEventListener( 'touchcancel', this._handleDragEnd );
		document.addEventListener( 'touchend', this._handleDragEnd );
		document.addEventListener( 'touchleave', this._handleDragEnd );
	}

	_handleLinkClick ( evt )
	{
		evt.preventDefault();

		this._href = evt.target.closest( 'a' ).href;
	}
	
	_handleTransition ()
	{
		this._slidesContainer.classList.add( 'sliding' );

		this._disableButtons();

		setTimeout( () => {
			if (
				this._loop
				&& ( this._currentIndex < 0 || this._currentIndex > this._slidesCount - 1 )
			)
			{
				this._createLoop();
			}
		
			if ( this._bookmarks )
			{
				this._bookmarksContainer.querySelector( '.current' ).classList.remove( 'current' );
				
				if ( this._autoWidth && !this._bookmarks[this._currentIndex] )
				{
					this._currentIndex = this._bookmarks.length - 1;
				}
				
				this._bookmarks[this._currentIndex].classList.add( 'current' );
			}

			if ( this._counter )
			{
				this._counter.querySelector( '.current' ).innerHTML = this._currentIndex + 1;
			}
			
			this._slidesContainer.classList.remove( 'sliding', 'grabbing' );
			
			this._slidesContainer.setAttribute( 'data-active-slide-index', this._currentIndex );
			
			this._switchCallback();
		}, 450 );
	}

	_initBookmarks()
	{
		if ( !this._bookmarksContainer || this._bookmarksContainer.children.length < 2 )
		{
			return;
		}

		this._bookmarksContainer.removeEventListener( 'click', this._handleBookmarksClick );

		/* Сокращение количества букмарок с числа слайдов до количества переключений */
		// if ( this._autoWidth )
		// {
		// 	if ( this._bookmarksContainer.children[0].innerHTML === '' )
		// 	{
		// 		this._bookmarksContainer.innerHTML = `${this._slides.map( () => '<li></li>' ).join( '' )}`;
		// 	}

		// 	let tailCount = 0, tailLength = 0;
		
		// 	for ( let i = this._slides.length - 1; i > 0; i-- )
		// 	{
		// 		const stepLength = this._calculateStep( this._slides[i] );
				
		// 		if ( tailLength + stepLength < this._slidesContainer.offsetWidth - this._calculateStep( this._slides[i - 1] ) )
		// 		{
		// 			tailCount++;
		// 			tailLength += stepLength;
		// 		}
		// 		else
		// 		{
		// 			break;
		// 		}
		// 	}

		// 	for ( let i = 0; i < tailCount; i++ )
		// 	{
		// 		this._bookmarksContainer.querySelector( 'li:last-child' ).remove();
		// 	}
		// }

		this._bookmarksContainer.classList.add( 'show' );
		this._bookmarks = Array.from( this._bookmarksContainer.children );
		// this._adjustSlides();

		if ( this._autoWidth && !this._bookmarks[this._currentIndex] )
		{
			this._currentIndex = this._bookmarks.length - 1;
		}

		this._bookmarks[this._currentIndex].classList.add( 'current' );
		this._bookmarksContainer.addEventListener( 'click', this._handleBookmarksClick );
	}

	_initButtons ()
	{
		if ( !this._buttons )
		{
			return;
		}
		
		this._buttons.classList.add( 'show' );
		
		this._disableButtons();
		this._buttons.addEventListener( 'click', this._handleButtonsClick );
		this._counter = this._buttons.querySelector( '.counter' );

		if ( !this._counter )
		{
			return;
		}

		this._counter.innerHTML = `<span class="current">${this._currentIndex + 1}</span><span class="total">${this._slidesCount}</span>`;
	}

	_initTouch ()
	{
		this._slidesContainer.addEventListener( 'mousedown', this._handleDragStart );
		this._slidesContainer.addEventListener( 'touchstart', this._handleDragStart, {passive: true} );

		Array.from( this._slidesContainer.querySelectorAll( 'a' ) ).forEach( ( it ) => {
			it.addEventListener( 'mousedown', this._handleLinkClick );

			it.addEventListener( 'click', ( evt ) => {
				evt.preventDefault();
			} );
		} );
	}

	_initValues ()
	{
		if ( !this._autoWidth )
		{
			this._step = this._calculateStep( this._slides[0] );
		}

		if ( this._loop )
		{
			Array.from( this._slidesContainer.children ).forEach( ( it ) => {
				if ( it.classList.contains( 'clone' ) )
				{
					it.remove();
				}
			} );
			
			this._createClones( 2 );
		}

		this._updateSlidesLength();
		this._slidesContainer.style.transform = '';
		this._currentIndex = 0;
		this._currentPosition = 0;
		// this._disableButtons();

		if ( this._counter )
		{
			this._counter.querySelector( '.current' ).innerHTML = this._currentIndex + 1;
		}

		if ( !this._bookmarksContainer )
		{
			return;
		}

		if ( this._bookmarksContainer.querySelector( '.current' ) )
		{
			this._bookmarksContainer.querySelector( '.current' ).classList.remove( 'current' );

			if ( !this._bookmarks )
			{
				this._bookmarks = Array.from( this._bookmarksContainer.children );
			}

			this._bookmarks[this._currentIndex].classList.add( 'current' );
		}
	}

	_loadImages ()
	{
		const showButtons = () => {
			this._element.classList.remove( 'loading' );
			this._updateSlidesLength();
			this._initButtons();
		};
		
		const images = Array.from( this._slidesContainer.querySelectorAll( 'img' ) );
		
		if ( images.length === 0 )
		{
			showButtons();
		}
		else
		{
			let isButtonsShow = false;
			
			const showReadyButtons = () => {
				if ( !isButtonsShow && images.length >= 1 && images.filter( ( img ) => isImgLoad( img ) ).length > 0 )
				{
					showButtons();
					
					isButtonsShow = true;
				}
				
				this._updateSlidesLength();
				this._disableButtons();
			};
			
			for ( let img of images )
			{
				if ( isImgLoad( img ) )
				{
					showReadyButtons();
				}
				else
				{
					img.addEventListener( 'load', showReadyButtons );
				}
			}
		}
	}

	_updateSlidesLength ()
	{
		if ( this._loop )
		{
			return;
		}
		
		this._slidesLength = 0;

		this._slides.forEach( ( it ) => {
			this._slidesLength += this._calculateStep( it );
		} );
	}
}
